module.exports = __webpack_public_path__ + "media/images/arrow-grey-6a1f2dca.png";